export class BadgeModel {

  alertCount: number;
  stockCount: number;
  
  constructor() {

  }
}